import { NavItem } from '../../NavList'

export const isNavItemExpandable = <T>(items: NavItem<T>[], id: string): boolean => {
  const item = items.find((item) => item.id === id)
  return !!item?.subItems?.length
}
